import React, { useState } from "react";
import { fetchModules } from "./Services/fetchModules";
import { useEffect } from "react";
import { insertMenus } from "./Services/insertMenus";
import { fetchMenus, fetchMenu1, fetchMenuspl,fetchMenusMain } from "./Services/fetchMenus";
import { deleteMenuById } from "./Services/deleteMenuById";
import { updateMenus } from "./Services/updateMenu";
const CreateSubMenu = () => {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);
  function handleCancelMenu(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "none";
    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "none";

    let addButtons = document.getElementById('add')
    addButtons.style.display = "block";


  }
  function addMenuPanel(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "block";

    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "block";
    let addButtons = document.getElementById('add');
    addButtons.style.display = "none";


  }

  const [ids, setIds] = useState(null);
  const [modules, setModules] = useState([]);
      const getModules =()=> {
          const fetch = async () => {
            const data = await fetchModules();
            setModules(data);
          };
          fetch();
        }
      const [menus,setMenus]= useState([]);
      const [menuspl,setMenuspl]= useState([]);
      const getMenus =()=> {
        const fetch = async () => {
          const data = await fetchMenusMain();
          setMenus(data);
        }
        fetch();
      }
      const getMenuspl =()=> {
        const fetchpl = async () => {
          const data = await fetchMenuspl();
          setMenuspl(data);
        }
        fetchpl();
      }
        useEffect(()=>{
      
          getModules();
          getMenus();
          getMenuspl();
        }, []);
      const [menu1, setMenu1] = useState('');
        useEffect(() => {
            const getMenu = async () => {
              const data = await fetchMenu1(ids);
              setMenu1(data);
            };
        
            getMenu();
          }, [ids]);
      const [editMenuName, setEditMenuName] = useState("");
      const [editModuleId, setEditModuleId] = useState(null);
      const [editParentMenuId, setEditParentMenuId] = useState(null);
        useEffect(() => {
          const selected = menu1
          if (selected) {
            setEditMenuName(selected.menuName);
            setEditModuleId(selected.moduleId);
            setEditParentMenuId(selected.parentMenuId);
          }
        }, [ids,menu1]);
      
        const handleEdit = async () => {
          if (!editMenuName || !editModuleId || !editParentMenuId) {
            alert("Please fill in all required fields.");
            return;
          }
      
          try {
            await updateMenus(ids, {
              menuName: editMenuName,
              moduleId: editModuleId,
              parentMenuId: editParentMenuId
            });
            
            getMenuspl(); // refresh table data
          } catch (err) {
            alert("Failed to update module");
          }
        };
        const [delId,setDelId]=useState(null);
          const handleDelete = async (id) => {
            await deleteMenuById(id);
            getMenuspl();
          };
          const [menuName, setMenuName] = useState("");
          const [moduleId, setModuleId] = useState(null);
          const [parentMenuId,setParentMenuId] = useState(null);
            const handleSubmit = async (e) => {
              e.preventDefault();
          
              await insertMenus({
                menuName,
                moduleId
              },parentMenuId);
              setMenuName("");
              setModuleId(0);
              setParentMenuId(0);
              getMenuspl();
            };
  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#!">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Create Sub Menu
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        {/* <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div> */}
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}

                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content h-350" style={{ paddingTop: "0.5rem;" }}>

                    <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row justify-content-left">
                        <div className="col-sm-12 col-12" id="divPanel" style={{ display: "none" }}>

                          <div className="card border mb-3">
                            <div className="card-body">

                              <div className="row gx-4">

                                <div className=" col-sm-3 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="a11">Menu Modules</label>
                                    <div className="input-group">

                                    <select className="form-select" id="a9"
                           value={moduleId}
                           onChange={(e) => setModuleId(e.target.value)}>
                            <option value={0}>Select</option>
                            {modules.map((module)=>(<option 
                            value={module.moduleId}>{module.moduleName}
                            </option>))}
                          </select>
                                      <span className="input-group-text">
                                        <i className="ri-nft-line" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-3 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="am">Parent Menu</label>
                                    <div className="input-group">

                                    <select className="form-select" id="am"
                           value={parentMenuId}
                           onChange={(e) => setParentMenuId(e.target.value)}>
                            <option value={0}>Select</option>
                            {menus.map((menu)=>(<option 
                            value={menu.menuId}>{menu.menuName}
                            </option>))}
                          </select>
                                      <span className="input-group-text">
                                        <i className="ri-nft-line" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-3 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="newMenu">New Menu <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                      <input type="text" id="newMenu" className="form-control" 
                                      value={menuName}
                                      onChange={(e) => setMenuName(e.target.value)}
                                      placeholder="Create Menu" />
                                      <button className="btn btn-outline-secondary" type="button">
                                        <i className="ri-menu-line text-black" />
                                      </button>
                                    </div>

                                  </div>

                                </div>

                                <div className="col-sm-3 col-12">
                                  <div className="mb-3 justify-content-right" style={{ float: "right" }}>
                                    <label className="form-label" htmlFor="newPwd">&nbsp;</label>
                                    <div className="input-group">
                                      <button type="button" className="btn btn-primary"
                                      onClick={handleSubmit}>
                                        Add
                                      </button>
                                    </div>

                                  </div>
                                </div>

                              </div>



                            </div>
                          </div>
                        </div>
                        {/*  */}

                        {/* d-flex gap-2 */}

                      </div>
                      {/* Row ends */}
                      <div className="card border">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="card-header">
                              <h5 className="card-title">Sub Menus</h5>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div id="addButtons" className="d-flex justify-content-end" style={{ paddingTop: "11px", width: "100%", paddingRight: "15px" }}>
                              <button type="button" id="cancel" className="btn btn-secondary " style={{ display: "none" }} onClick={handleCancelMenu}>
                                Cancel
                              </button>
                              <button type="button" id="add" className="btn btn-primary" onClick={addMenuPanel}>
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="card-body pt-15">
                          {/* Table starts */}
                          {modules.length > 0 && (
                          <div className="table-responsive">
                            <table id="scrollVertical" className="table truncate m-0 align-middle">
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Module Name</th>
                                  <th>Parent Menu</th>
                                  <th>Menu Name</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              {/* <tbody>
                                <tr>
                                  <td>#1</td>
                                  <td>
                                    User Module
                                  </td>
                                  <td>No</td>
                                  <td>
                                    User Management
                                  </td>

                                  <td>
                                    <div className="d-inline-flex gap-1">
                                      <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                        <i className="ri-delete-bin-line" />
                                      </button>
                                      <button class="btn btn-outline-success btn-sm"
                                        data-bs-toggle="modal" data-bs-target="#editModules"
                                        data-bs-title="Edit Modules" type="button" onClick={() => { setIds(1) }}>
                                        <i class="ri-edit-box-line"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#2</td>
                                  <td>
                                    User Module
                                  </td>
                                  <td>User Management</td>
                                  <td>
                                    Add User
                                  </td>

                                  <td>
                                    <div className="d-inline-flex gap-1">
                                      <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                        <i className="ri-delete-bin-line" />
                                      </button>
                                      <button class="btn btn-outline-success btn-sm"
                                        data-bs-toggle="modal" data-bs-target="#editModules"
                                        data-bs-title="Edit Modules" type="button" onClick={() => { setIds(2) }}>
                                        <i class="ri-edit-box-line"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#3</td>
                                  <td>
                                    User Module
                                  </td>
                                  <td>User Management</td>
                                  <td>
                                    View User
                                  </td>

                                  <td>
                                    <div className="d-inline-flex gap-1">
                                      <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                        <i className="ri-delete-bin-line" />
                                      </button>
                                      <button class="btn btn-outline-success btn-sm"
                                        data-bs-toggle="modal" data-bs-target="#editModules"
                                        data-bs-title="Edit Modules" type="button" onClick={() => { setIds(3) }}>
                                        <i class="ri-edit-box-line"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#4</td>
                                  <td>
                                    User Module
                                  </td>
                                  <td>User Management</td>
                                  <td>
                                    Add Department
                                  </td>

                                  <td>
                                    <div className="d-inline-flex gap-1">
                                      <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                        <i className="ri-delete-bin-line" />
                                      </button>
                                      <button class="btn btn-outline-success btn-sm"
                                        data-bs-toggle="modal" data-bs-target="#editModules"
                                        data-bs-title="Edit Modules" type="button" onClick={() => { setIds(4) }}>
                                        <i class="ri-edit-box-line"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody> */}
                              <tbody>
                              {menuspl.map((men, index) => (
              <tr key={men.menuId}>
                <td>#{index + 1}</td>
                <td>{men.moduleName}</td>
                <td>{men.parentMenuName}</td>
                <td>{men.menuName}</td>
                <td>
                  <div className="d-inline-flex gap-1">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#delRow"
                      onClick={() => setDelId(men.menuId)}
                    >
                      <i className="ri-delete-bin-line" />
                    </button>
                    <button
                      className="btn btn-outline-success btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#editModules"
                      data-bs-title="Edit Modules"
                      type="button"
                      onClick={() => setIds(men.menuId)}
                    >
                      <i className="ri-edit-box-line"></i>
                    </button>
                  </div>
                </td>
              </tr>
      ))}
       {menus.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No modules found.
                </td>
              </tr>
            )}
                              </tbody>
                            </table>
                          </div>)}
                          {/* Table ends */}
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="delRowLabel">
                                    Confirm
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  Are you sure you want to delete the menus from list?
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleDelete(delId)}>Yes</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Modal Edit Row */}
                          <div className="modal fade" id="editModules" tabIndex={-1} aria-labelledby="editModulesLabel" aria-hidden="true">
                            <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="iconRowLabel">
                                    Edit
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  <div className="row justify-content-left">
                                    <div className="col-sm-12 col-12" id="divPanel">

                                      <div className="card border mb-3">
                                        <div className="card-body">

                                          <div className="row gx-4">

                                            <div className=" col-sm-4 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="editM">Menu Modules</label>
                                                <div className="input-group">

                                                <select className="form-select" id="editM"
                           value={editModuleId}
                           onChange={(e) => setEditModuleId(e.target.value)}>
                            <option value={0}>Select</option>
                            {modules.map((module)=>(<option 
                            value={module.moduleId}>{module.moduleName}
                            </option>))}
                          </select>
                                                  <span className="input-group-text">
                                                    <i className="ri-nft-line" />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-4 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="editMM">Parent Menu</label>
                                                <div className="input-group">

                                                  <select className="form-select" id="editMM"
                                                  value={editParentMenuId}
                                                  onChange={(e) => setEditParentMenuId(e.target.value)}>
                                                    
                                                    <option value={0}>Select</option>
                                                    {menus.map((menu)=>(<option 
                                                    value={menu.menuId}>{menu.menuName}
                                                    </option>))}
                                                  </select>
                                                  <span className="input-group-text">
                                                    <i className="ri-nft-line" />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-4 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="newMenu">New Menu <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                  <input type="text" id="newMenu" className="form-control" 
                                                  value={editMenuName}  onChange={
                                                    (e) => setEditMenuName(e.target.value)} />
                                                  <button className="btn btn-outline-secondary" type="button">
                                                    <i className="ri-menu-line text-black" />
                                                  </button>
                                                </div>

                                              </div>

                                            </div>



                                          </div>



                                        </div>
                                      </div>
                                    </div>
                                    {/*  */}

                                    {/* d-flex gap-2 */}

                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleEdit}>Edit</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>


  );
}
export default CreateSubMenu;




